import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import {
  Box,
  Button,
  Tooltip,
  Typography,
  Divider,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableBody,
  TablePagination,
} from "@mui/material";
import FilterBox from "../../../components/FilterBox";
import BasicButtons from "../../../components/Button";
import PaginationTable from "../../../components/PaginationTable";
import "../../../scss/main.css";
import { useNavigate } from "react-router-dom";
import {
  deleteDataHandler,
  getDataHandlerWithToken,
  putDataHandlerWithToken,
} from "../../../apiconfig/service";
import toast from "react-hot-toast";
import { saveAs } from "file-saver";
import BlockModal from "../../../Modal/BlockModal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import typographyStyles from "../../../theme/Typography";
import Loading from "../../../components/Loading";
import DataNotFound from "../../../components/DataNotFound";
import AlertDialog from "../../../components/AlertDialog";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import {
  //   DndProvider,
  DragDropContext,
  Draggable,
  Droppable,
} from "@hello-pangea/dnd";
import { DragHandle } from "@mui/icons-material";

const columns = [
  "Sr.No.",
  "Stage",
  "Recipe Type",
  "Created Date & Time",

  "Status",
  "Action",
];
const se = [
  { key: "Trying to Conceive", value: "TRYINGTOCONCEIVE" },
  { key: "Pregnant", value: "PREGNANT" },
  { key: "Postpartum (0-6 Weeks After Birth)", value: "POSTPARTUM" },
  {
    key: "Beyond -(6 Weeks + After Birth (Weeks, months, Years))",
    value: "BEYOND",
  },
  { key: "Babies and Kids", value: "BABIESANDKIDS" }, // New object added
];


const PaginationTableStyle = {
  rowStyle: {
    backgroundColor: "rgb(225,140,168)",
    color: "white",
  },
  cellStyle: {
    textAlign: "left",
    // fontFamily: "Poppins",
    padding: "4px",
    paddingLeft: "20px",
    height: "49px",
    fontSize: "0.875rem",
  },

  tableStyle: {
    textAlign: "left",
    color: "white",
    fontSize: 14,
    fontWeight: 700,
    fontFamily: "Poppins",
    padding: "4px",
    paddingLeft: "20px",
  },
};
const RecipeType = () => {
  const navigate = useNavigate();
  const [couponList, setCouponList] = useState([]);
  const [render, setRender] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState();
  const [name, setName] = useState();
  const [blockModalOpen, setBlockModalOpen] = useState(false);
  const [blockId, setBlockId] = useState(null);
  const [currentPage, setcurrentPage] = useState(1);




  const fetchData = async () => {
    try {
      setLoading(true);
      const query = {
        limit: Number.MAX_SAFE_INTEGER,
      };
      const res = await getDataHandlerWithToken("listRecipeType", query);
      if (res.responseCode === 200) {

        setCouponList(res?.result?.recipeTypes || []);
        setFilteredData(res?.result?.recipeTypes || []);
      } else {
        toast.error(res?.data?.responseMessage);
      }
    } catch (error) {
      console.error("Error fetching coupon list:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleEdit = (id) => {
    navigate(`/recipeType/EditRecipeType`, { state: { recipeTypeId: id } });
  };
  const handleBlock = (id, name, status) => {
    setBlockId(id);
    setStatus(status == "ACTIVE" ? "BLOCK" : "ACTIVE");
    setName(name);
    setBlockModalOpen(true);
  };

  const handleClickOpen = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };
  const handleBlockConfirm = async () => {
    // Handle block action
    const id = blockId;
    const query = {
      recipeTypeId: id,
    };

    try {
      const res = await putDataHandlerWithToken(
        "blockUnblockRecipeType",
        {},
        query
      );

      if (res.responseCode === 200) {
        //setRender(!render);
        setBlockModalOpen(false);

        fetchData();

        toast.success(res.responseMessage);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }

    console.log("Block button clicked for row id:", id);
  };
  const handleBlockCancel = () => {
    setBlockModalOpen(false);
  };

  const formatDateTime = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const handleView = (id) => {
    console.log(id);
    navigate(`/couponListing/viewCoupon`, { state: { couponId: id } });
  };

  const handleDelete = async (id) => {
    const query = { recipeTypeId: id };
    try {
      const res = await deleteDataHandler("deleteRecipeType", query);
      if (res.responseCode === 200) {
        toast.success(res.responseMessage);
        fetchData();

        const updatedCouponList = couponList?.filter(
          (coupon) => coupon.id !== id
        );
        setCouponList(updatedCouponList || []);
        setFilteredData(updatedCouponList || []);
      } else {
        toast.error(res?.data?.responseMessage);
      }
    } catch (error) {
      toast.error("Failed to delete coupon");
      console.error("Error deleting coupon:", error);
    } finally {
      handleClose();
    }
  };

  const handleFilterChange = (filterCriteria) => {
    let filtered = couponList;

    if (filterCriteria.searchText) {
      filtered = filtered.filter((coupon) =>
        coupon.name
          .toLowerCase()
          .includes(filterCriteria.searchText.toLowerCase().trim())
      );
    }

    const parseCustomDate = (romDate) => {
      const year = romDate.$y;
      const month = romDate.$M;
      const day = romDate.$D;
      const hours = romDate.$H;
      const minutes = romDate.$m;
      const seconds = romDate.$s;
      return new Date(year, month, day, hours, minutes, seconds);
    };

    if (filterCriteria.fromDate) {
      const fromDate = parseCustomDate(filterCriteria.fromDate);
      filtered = filtered.filter(
        (coupon) => new Date(coupon.createdAt) >= fromDate
      );
    }

    if (filterCriteria.toDate) {
      const toDate = parseCustomDate(filterCriteria.toDate);
      filtered = filtered.filter(
        (coupon) => new Date(coupon.createdAt) <= toDate
      );
    }

    if (
      filterCriteria.selectedValue &&
      filterCriteria.selectedValue !== "All"
    ) {
      filtered = filtered.filter(
        (coupon) => coupon.stage === filterCriteria.selectedValue
      );
    }

    setFilteredData(filtered);
  };

  const handleDownloadCSV = () => {
    const dataWithoutId = couponList?.map(({ _id, ...rest }) => rest);
    const headers = Object.keys(dataWithoutId[0]);
    let csvContent = headers.join(",") + "\n";
    csvContent += dataWithoutId
      .map((row) => headers.map((header) => row[header]).join(","))
      .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(2, "0")}`;

    // Create the filename
    const filename = `RecipeType_${formattedDate}.csv`;

    // Use FileSaver.js to save the Blob as a file
    saveAs(blob, filename);
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;

    // Reorder only the current page data (filteredData), not the entire dataset
    const currentPageData = [...filteredData];
    const [movedRow] = currentPageData.splice(source.index, 1);
    currentPageData.splice(destination.index, 0, movedRow);

    // Update the filteredData with the reordered rows
    setFilteredData(currentPageData);
    setCouponList(currentPageData);

    // Prepare the reordered data to be sent to the database, ensuring global indices are updated
    const updatedOrderArray = currentPageData.reverse().map((item, index) => ({
      recipeTypeId: item._id,
      orderId: (index + 1).toString(),
    }));

    console.log("Reordered data to update:", updatedOrderArray);

    // Persist the new order to the database
    saveOrderToDB(updatedOrderArray);
  };


  useEffect(() => {
    fetchData();
  }, [render]);


  const saveOrderToDB = async (updatedOrderArray) => {
    try {
      const data = { order: updatedOrderArray };

      const res = await putDataHandlerWithToken("updateRecipeTypeOrder", data);
      if (res?.responseCode === 200) {
        toast.success("Order updated successfully!");
        fetchData();
      } else {
        toast.error("Failed to update order");
      }
    } catch (error) {
      console.error("Error saving order to the database:", error);
      toast.error("An error occurred while updating order");
    }
  };

  return (
    <DashboardLayout sectionName="Subscription" showBackButtonSection={false}>
      <Box className="category-container">
        <Box className="heading-container-top">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ ...typographyStyles.h4 }}>
              Recipe Types
            </Typography>
          </Box>
          <Box className="button-container">
            <Box className="button-sub-container">
              <BasicButtons text="Download CSV" onClick={handleDownloadCSV} />
              <BasicButtons
                text="+Add Recipe Type"
                onClick={() => navigate("/recipeType/AddRecipeType")}
              />
            </Box>
          </Box>
        </Box>
        <Divider />
        <Box className="table-container">
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50vh",
              }}
            >
              <Loading />
            </Box>
          ) : filteredData?.length < 1 ? (
            <DataNotFound />
          ) :

            // (
            //   <PaginationTable
            //   columns={columns}
            //   data={Array.isArray(couponList) ? couponList.map((row, index) => {
            //     const stageKeys = se
            //       .filter((option) => row.stage.includes(option.value))
            //       .map((item) => item.key);
            //     const stageText = stageKeys.join(", ") || "Unknown Stage";
            //     return {
            //       sr_no: index + 1,
            //       stage: (
            //         <Tooltip title={stageText} arrow>
            //           <span>
            //             {stageText.length > 20
            //               ? `${stageText.substring(0, 20)}...`
            //               : stageText}
            //           </span>
            //         </Tooltip>
            //       ),
            //       recipe_type: row.recipeType,
            //       created_date_time: new Date(row.createdAt).toLocaleString(
            //         "en-US",
            //         {
            //           year: "numeric",
            //           month: "long",
            //           day: "numeric",
            //           hour: "numeric",
            //           minute: "numeric",
            //           hour12: true,
            //         }
            //       ),
            //       status: row.status,
            //       action: (
            //         <Box className="row-button-container" sx={{ gap: "15%" }}>
            //           <EditIcon
            //             onClick={() => handleEdit(row._id)}
            //             sx={{
            //               color: "rgb(225,140,168)",
            //               borderColor: "rgb(225,140,168)",
            //               fontFamily: "'Poppins', sans-serif",
            //               cursor: "pointer",
            //             }}
            //           />
            //           {/* <DeleteIcon
            //             onClick={() => handleClickOpen(row)}
            //             sx={{
            //               color: "rgb(225,140,168)",
            //               borderColor: "rgb(225,140,168)",
            //               fontFamily: "'Poppins', sans-serif",
            //               cursor: "pointer",
            //             }}
            //           /> */}
            //           <BlockIcon
            //             onClick={() =>
            //               handleBlock(row._id, row.recipeType, row.status)
            //             }
            //             sx={{
            //               color: row.status === "ACTIVE" ? "green" : "red",
            //               borderColor: "rgb(225,140,168)",
            //               fontFamily: "'Poppins', sans-serif",
            //               cursor: "pointer",
            //             }}
            //           />
            //         </Box>
            //       ),
            //     };
            //   }) : []}
            // />

            // )

            (
              <TableContainer
                component={Paper}
                sx={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                {loading ? (
                  <Loading />
                ) : (
                  <>
                    {filteredData?.length === 0 ? (
                      <DataNotFound />
                    ) : (
                      <Table sx={{ minWidth: 800 }}>
                        <TableHead stickyHeader>
                          <TableRow sx={PaginationTableStyle.rowStyle}>
                            {columns.map((e, i) => (
                              <TableCell
                                key={i}
                                align="left"
                                sx={PaginationTableStyle.tableStyle}
                              >
                                {e}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId="programList">
                            {(provided) => (
                              <TableBody
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                              >
                                {filteredData?.map((item, i) => {
                                  const stageKeys = se
                                    .filter((option) => item.stage.includes(option.value))
                                    .map((item) => item.key);

                                  const stageText = stageKeys.join(", ") || "Unknown Stage";
                                

                                  return (
                                    <Draggable
                                      key={item?.id}
                                      draggableId={item?._id}
                                      index={i}
                                    >
                                      {(provided, snapshot) => (
                                        <TableRow
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={{
                                            backgroundColor: snapshot.isDragging
                                              ? "#faebf0"
                                              : "inherit",
                                            ...provided.draggableProps.style,
                                            width: "100%",
                                          }}
                                          sx={PaginationTableStyle.rowStyle}
                                          key={i}
                                        >
                                          <TableCell
                                            scope="row"
                                            sx={PaginationTableStyle.cellStyle}
                                          >
                                            {currentPage
                                              ? (currentPage - 1) * 10 + (i + 1)
                                              : i + 1}
                                          </TableCell>

                                          <TableCell
                                            sx={PaginationTableStyle.cellStyle}
                                          >
                                            <Tooltip title={stageText} arrow>
                                              <span>
                                                {stageText.length > 20
                                                  ? `${stageText.substring(0, 20)}...`
                                                  : stageText}
                                              </span>
                                            </Tooltip>
                                          </TableCell>

                                          <TableCell
                                            sx={PaginationTableStyle.cellStyle}
                                          >
                                            {item.recipeType}
                                          </TableCell>


                                          <TableCell
                                            sx={PaginationTableStyle.cellStyle}
                                          >
                                            {item?.createdAt
                                              ? new Date(
                                                item?.createdAt
                                              ).toLocaleString("en-US", {
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                                hour: "numeric",
                                                minute: "numeric",
                                                hour12: true,
                                              })
                                              : "NA"}
                                          </TableCell>

                                          <TableCell
                                            sx={PaginationTableStyle.cellStyle}
                                          >
                                            {item?.status ? item?.status : "NA"}
                                          </TableCell>

                                          <TableCell
                                            sx={PaginationTableStyle.cellStyle}
                                          >

                                            <EditIcon
                                              onClick={() => handleEdit(item._id)}
                                              sx={{
                                                color: "rgb(225,140,168)",
                                                borderColor: "rgb(225,140,168)",
                                                fontFamily:
                                                  "'Poppins', sans-serif",
                                                cursor: "pointer",
                                                ml: 2,
                                                mr: 2,
                                              }}
                                            />
                                            <BlockIcon
                                              onClick={() =>
                                                handleBlock(item._id, item.recipeType, item.status)
                                              }
                                              sx={{
                                                color:
                                                  item.status === "ACTIVE"
                                                    ? "green"
                                                    : "red",
                                                borderColor: "rgb(225,140,168)",
                                                fontFamily:
                                                  "'Poppins', sans-serif",
                                                cursor: "pointer",
                                              }}
                                            />

                                            <DeleteIcon
                                              onClick={() => handleClickOpen(item)}
                                              sx={{
                                                color: "rgb(225,140,168)",
                                                borderColor: "rgb(225,140,168)",
                                                fontFamily: "'Poppins', sans-serif",
                                                cursor: "pointer",
                                                ml: 2,
                                                mr: 2,
                                              }}
                                            />
                                            <DragHandle sx={{ ml: 4 }} />
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </Draggable>
                                  );
                                })}
                                {provided.placeholder}
                              </TableBody>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </Table>
                    )}
                  </>
                )}

                {/* {shouldShowPagination && (
            <TablePagination
              rowsPerPageOptions={rowsPerPageOptions}
              component="div"
              count={filteredData?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                "& .MuiTablePagination-selectIcon": {
                  color: "rgb(225,140,168)",
                },
              }}
            />
          )} */}
              </TableContainer>
            )
          }
        </Box>
      </Box>
      <AlertDialog
        open={open}
        handleClose={handleClose}
        handleDelete={() => handleDelete(selectedRow?._id)}
        title="Delete Recipe Type?"
        description={`Are you sure you want to delete the recipe type  "${selectedRow?.recipeType}"? This action cannot be undone.`}
      />
      {blockModalOpen && (
        <BlockModal
          title="Recipe Type"
          status={status}
          name={name}
          onClose={handleBlockCancel}
          onBlock={handleBlockConfirm}
        />
      )}

    </DashboardLayout>
  );
};

export default RecipeType;
